import { render, staticRenderFns } from "./examineTasK.vue?vue&type=template&id=0c1135ac&scoped=true&"
import script from "./examineTasK.vue?vue&type=script&lang=js&"
export * from "./examineTasK.vue?vue&type=script&lang=js&"
import style0 from "./examineTasK.vue?vue&type=style&index=0&id=0c1135ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1135ac",
  null
  
)

component.options.__file = "examineTasK.vue"
export default component.exports